import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import { IDeviceStateControllerReturn } from '../../../services/devicestate/DeviceStateController';
import { SlideGalleryController } from './SlideGalleryController';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';

export interface IImageItem {
  src: string;
  header?: string;
  ratio: number;
}

interface IProps {
  dsc: IDeviceStateControllerReturn;
  images: IImageItem[];
  height: number;
}

const ImageSlideGallery = (props: IProps) => {

  const c = SlideGalleryController({}) 
      //  ${(props.dsc.isMobile ? "w-10/12":"w-12/12")}

  return (
    <div
      //className={`w-full mx-auto`}
      //className={`bg-slate-200 h-[${props.height}px]`}
        className={``}
    >   
        <Swiper
          //ref={(it) => { c.setRefSwiper(it) }}
          modules={[Navigation, Pagination, Scrollbar, Autoplay]}
          direction={"horizontal"}
          spaceBetween={10}
          onSwiper={(it) => { c.setSwiperInstance(it) }}
          onSlideChange={(it) => c.handleSlideChange(it)}
          //slidesPerView={getSlidesPerView()}
          //navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
          //scrollbar={{ draggable: true, el: '.swiper-scrollbar', }}
          //pagination={{ clickable: true, el: '.swiper-pagination' }}
          //autoplay={{ delay: 3000, disableOnInteraction: true }}
          loop={true}
          //className="swiper w-full rounded-lg shadow-lg cursor-pointer  flex flex-col bg-gray-800"

          //spaceBetween={1}
          //modules={[Navigation, Pagination, Scrollbar, Autoplay]}
          //onSwiper={(it) => { c.setSwiperInstance(it) }}
          //onSlideChange={(it) => c.handleSlideChange(it)}
          slidesPerView={1}
          navigation
          //scrollbar={{ draggable: true }}
          //navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
          pagination={{ clickable: true }}
          //autoplay={{ delay: 3000 }}
          //loop={true}
  
          className={`w-full rounded-lg shadow-lg cursor-pointer overflow-hidden`}
          onDoubleClick={() => { }}
        >

        <div className="flex" >
          {props.images.map((it, index) => (
            <SwiperSlide key={index} className=''>
              <img
                //height={50}
                width={(props.height) * it.ratio}
                key={index}
                src={it.src}
                alt={`Slide ${index + 1}`}
                className={`object-cover rounded-2xl m-auto`}
              //className="w-full h-64 object-cover" 
              />
            </SwiperSlide>
          ))}
        </div>
        
      {/* <div className="h-full left-0 w-[6rem] top-0 m-auto swiper-button-prev"></div>
      <div className="h-full right-0 w-[6rem] top-0 m-auto swiper-button-next"></div> */}

      <div id="swiper_footer" className='relative h-10 w-full' >
        <div className="swiper-pagination" />
      </div>
    </Swiper>

    </div>
  );
};

export default ImageSlideGallery;
